// extracted by mini-css-extract-plugin
export var container = "_dd-0";
export var popoverContent = "_dd-1";
export var tosLink = "_dd-2";